import { useQuery } from '@tanstack/react-query';
import { getPortfolioRules } from 'services/portfolios/portfolioService';

export const useGetPortfolioRules = (brUid: string, enable: boolean) =>
  useQuery({
    queryKey: ['useGetPortfolioRules', brUid],
    queryFn: () => getPortfolioRules(brUid),
    enabled: !!brUid && enable,
  });
